module.exports = __webpack_public_path__ + "img/dz.ce174bd3.jpg";